import { connect, Component, Currency } from "macguffin"
import Timeout from 'macguffin/Utils/Timeout'
import BackgroundImage from "utils/BackgroundImage"

const { random } = Math
const COUNT_UP_DIVISIONS = 59
const COUNT_UP_DELAY = 5000
const FAKE_OFFSET_SCALE = 1 // when we resume, make it look like we're ticking up from something

const JACKPOT_FONT_SCALE = 0.07

const headerStyle = {
    backgroundPosition: "center"
}

// cut a number up into a specified number of pieces
function divideRandomly(number, partCount) {
    // create some random divisions between 0 and 1
    const dividers = [0]
    for (let i = 1; i < partCount; i++) {
        dividers.push(random())
    }
    dividers.push(1)
    dividers.sort((a, b) => { return a - b })

    // use the gaps between the dividers to distribute the parts uniformly
    const parts = []
    for (let i = 1; i < partCount + 1; i++) {
        const part = (dividers[i] - dividers[i - 1]) * number
        parts.push(part)
    }

    return parts
}

@connect(state => ({
    jackpot: state.game.jackpot
}), {})
export default class JackpotMeter extends Component {
    constructor(props) {
        super(props)

        this.timeouts = []
    }

    componentWillMount() {
        if (this.props.jackpot) {
            this.cancelTimeouts()
            this.createRandomCountUp(this.props.jackpot, this.props.jackpot * FAKE_OFFSET_SCALE)
        }
    }

    componentWillReceiveProps(nextProps) {
        const { props, state, timeouts } = this
        const currentProps = props

        if (!state || !state.jackpot) {
            this.cancelTimeouts()
            this.createRandomCountUp(nextProps.jackpot, nextProps.jackpot * FAKE_OFFSET_SCALE)
            return
        }

        if (nextProps.jackpot > currentProps.jackpot) {
            this.cancelTimeouts()
            this.createRandomCountUp(nextProps.jackpot, nextProps.jackpot)
        } else if (nextProps.jackpot < currentProps.jackpot) {
            timeouts && timeouts.forEach((timeoutID) => {
                timeoutID.cancel()
            })
            this.setState({ jackpot: nextProps.jackpot })
        }
    }

    cancelTimeouts() {
        const { timeouts } = this
        timeouts.forEach((timeoutID) => {
            timeoutID.cancel()
        })
    }

    // create a fake count up to the latest value (so we don't have to poll the server all the time)
    createRandomCountUp(target, start) {
        const { state, timeouts } = this
        const { jackpot = start } = state || {}
        const difference = target - jackpot

        if (difference > 0) {
            const values = divideRandomly(difference, COUNT_UP_DIVISIONS)
            const intervals = divideRandomly(COUNT_UP_DELAY, COUNT_UP_DIVISIONS)
            let runningTime = 0
            values.forEach((value, index) => {
                runningTime += intervals[index]
                timeouts.push(new Timeout(() => { this.updateJackpot(value, start) }, runningTime))
            })
        } else {
            timeouts.push(new Timeout(() => {
                this.setState({ jackpot })
            }, 100))
        }
    }

    updateJackpot = (value, start) => {
        const { jackpot = start } = this.state || {}
        this.setState({ jackpot: jackpot + value })
    }

    render() {
        const { props: { height, logo }, state } = this
        const { jackpot } = state || {}
        const textStyle = {
            fontSize: `${height * JACKPOT_FONT_SCALE}px`
        }

        return <BackgroundImage key="jackpotHeader" className="jackpot" assetName={logo} style={headerStyle}>
            {jackpot && <h1 style={textStyle}>{Currency.format(jackpot)}</h1>}
        </BackgroundImage>
    }
}
